// Banner lateral de AccessCloud del PMS.
//
// Visible en todos los entornos. Para volver a dejarlo solo en desarrollo
// (la config de runtime define window._env_.URL_API; en dev apunta a
// api-dev), cambiar ENABLED_IN_PRODUCTION a false.
const ENABLED_IN_PRODUCTION = true;

export function isAccessCloudBannerEnabled() {
    const urlApi = (window._env_ && window._env_.URL_API) || "";
    const isDevEnvironment = urlApi.includes("api-dev");
    return isDevEnvironment || ENABLED_IN_PRODUCTION;
}
